import { AlertDialog } from '@/components/ui/alert-dialog';
import React from 'react';

interface MatchingKnoxDialogProps {
  open: boolean;
  supplierName?: string;
  onContinue: () => void;
  onTerminate: () => void;
}

const MatchingKnoxDialog: React.FC<MatchingKnoxDialogProps> = ({ open, supplierName, onContinue, onTerminate }) => (
  <AlertDialog
    id='matching-knox-dialog'
    open={open}
    description={
      <span className='text-md'>
        Quick check result saved.
        <br />
        There is an open Knox verify process for <span className='font-bold text-black'>{supplierName}</span>, should we terminate
        it?
      </span>
    }
    secondaryButton={{
      className: 'bg-black text-white hover:bg-gray-900',
      label: 'Continue Knox verify',
      onClick: onContinue,
    }}
    primaryButton={{
      label: 'Terminate Knox verify',
      onClick: onTerminate,
    }}
  />
);

export default MatchingKnoxDialog;
